const $ = jQuery.noConflict();

class Slider {
	constructor(selector, args = {}) {
		this.selector = selector;
		this.args = args;
	}

	getDefaultSlickSettings() {
		return {
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			speed: 600,
		};
	}

	/**
	 * Override our default slick settings with args provided to the class.
	 */
	getSlickSettings() {
		return Object.assign({}, this.getDefaultSlickSettings(), this.args);
	}

	init() {
		const settings = this.getSlickSettings();

		$(this.selector).on('init', function (e, slick) {
			if (slick.slideCount) {
				e.currentTarget.setAttribute(
					'data-slide-count',
					slick.slideCount
				);
			}

			disableNextArrow(slick);
		});

		if (2 === $(this.selector).children().length) {
			settings.useTransform = false;
			settings.easing = 'swing';
		}

		const slider = $(this.selector).slick(settings);

		$(window).on('block-library-change', function () {
			$('.slick-slider').slick('refresh');
		});

		if (settings.customCallbacks && true === settings.customCallbacks) {
			slider
				.on(
					'beforeChange',
					function (event, slick, currentSlide, nextSlide) {
						if (
							slick.slideCount - 1 === currentSlide &&
							0 === nextSlide
						) {
							const activeSlides = event.target.querySelectorAll(
								'.slick-slide.slick-active'
							);

							if (activeSlides.length) {
								activeSlides.forEach((slide, index) => {
									if (
										slide &&
										index + 1 === activeSlides.length
									) {
										slide.classList.add(
											'slick-clone-current'
										);

										if (slide.nextElementSibling) {
											slide.nextElementSibling.classList.add(
												'slick-clone-current'
											);
										}
									} else if (slide && 0 !== index) {
										slide.classList.add(
											'slick-clone-current'
										);
									}
								});
							}
						} else if (
							slick.slideCount - 1 === nextSlide &&
							0 === currentSlide
						) {
							const activeSlides =
								event.target.querySelectorAll('.slick-active');

							if (activeSlides.length) {
								activeSlides.forEach((slide, index) => {
									if (0 === index) {
										slide.classList.add(
											'slick-clone-current'
										);

										if (slide.previousElementSibling) {
											slide.previousElementSibling.classList.add(
												'slick-clone-current'
											);
										}
									} else if (
										index <
										activeSlides.length - 1
									) {
										slide.classList.add(
											'slick-clone-current'
										);
									}
								});
							}
						}
					}
				)
			.on('afterChange', function (event, slick, currentSlide) { // eslint-disable-line
					$('.slick-clone-current').removeClass(
						'slick-clone-current'
					);
					disableNextArrow(slick);
				})
			.on('setPosition', function (event, slick) { // eslint-disable-line
					disableNextArrow(slick);
				});
		}
	}
}

const disableNextArrow = (slick) => {
	if (
		slick.options &&
		true === slick.options.variableWidth &&
		true === slick.options.arrows &&
		slick.slideCount > 1
	) {
		if (slick.$slides) {
			const lastSlide = slick.$slides.last();
			const lastSlideRight = lastSlide.offset().left + lastSlide.width();
			const containerRight =
				slick.$list.offset().left + slick.$list.width();

			if (lastSlideRight <= containerRight) {
				slick.$nextArrow.addClass('slick-disabled');
			} else {
				slick.$nextArrow.removeClass('slick-disabled');
			}
		}
	}
};

const SimpleSlider = new Slider('.gallery-slider__slider', {
	prevArrow:
		'<button type="button" class="slick-prev slick-arrow--color-alt">Previous</button>',
	nextArrow:
		'<button type="button" class="slick-next slick-arrow--color-alt">Next</button>',
});
const TestimonialSlider = new Slider('.block-testimonial-slider__slider', {
	prevArrow:
		'<button type="button" class="slick-prev slick-arrow--secondary">Previous</button>',
	nextArrow:
		'<button type="button" class="slick-next slick-arrow--secondary">Next</button>',
	dots: false,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				dots: true,
			},
		},
	],
});
const RelatedPostsSlider = new Slider('.block-related-posts__slider', {
	prevArrow:
		'<button type="button" class="slick-prev slick-arrow--secondary">Previous</button>',
	nextArrow:
		'<button type="button" class="slick-next slick-arrow--secondary">Next</button>',
	slidesToShow: 3,
	infinite: true,
	dots: true,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
			},
		},
	],
});
const BlogCardsGrid = new Slider('.block-blog-cards__slider', {
	prevArrow:
		'<button type="button" class="slick-prev slick-arrow--secondary">Previous</button>',
	nextArrow:
		'<button type="button" class="slick-next slick-arrow--secondary">Next</button>',
	slidesToShow: 3,
	infinite: true,
	dots: true,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
			},
		},
	],
	customCallbacks: true,
});
const FeaturedPostSlider = new Slider('.block-featured-post-slider__slider', {
	prevArrow:
		'<button type="button" class="slick-prev slick-arrow--secondary">Previous</button>',
	nextArrow:
		'<button type="button" class="slick-next slick-arrow--secondary">Next</button>',
	slidesToShow: 2,
	infinite: true,
	dots: false,
	responsive: [
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 1,
				dots: true,
			},
		},
	],
});
const FluidSlider = new Slider('.gallery-slider__slider-fluid', {
	prevArrow:
		'<button type="button" class="slick-prev slick-arrow--color-alt">Previous</button>',
	nextArrow:
		'<button type="button" class="slick-next slick-arrow--color-alt">Next</button>',
	centerMode: true,
	variableWidth: true,
});
const HeroSlider = new Slider('.block-hero-slider__slider', {
	prevArrow: '<button type="button" class="slick-prev">Previous</button>',
	nextArrow: '<button type="button" class="slick-next">Next</button>',
});
const TabButtonsSlider = new Slider('.block-tabs__button-row', {
	arrows: true,
	dots: false,
	centerMode: false,
	variableWidth: true,
	infinite: false,
	customCallbacks: true,
});
export {
	SimpleSlider,
	TestimonialSlider,
	BlogCardsGrid,
	FeaturedPostSlider,
	FluidSlider,
	HeroSlider,
	TabButtonsSlider,
	RelatedPostsSlider,
};
